export class ProductsAdditionalInfo {
    productId!: string;
    productName!: string;
    productAdditionalInfo!: string;
    daoLocationKey!: string;
    productKeyMapping!: boolean;
  }